import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { queryClient } from "@/lib/queryClient";

// Feb 2026 — dev-mode only: swallow unhandled AxiosError rejections so
// webpack-dev-server's error overlay stops black-screening the app when a
// role-guarded endpoint returns 4xx and the caller didn't await/catch.
// Hooks that DO catch (useIceWater, useTrackSweep, etc.) toast the error;
// hooks that don't render nothing on failure. Real TypeError/ReferenceError
// bugs still bubble through the overlay because we only intercept when the
// rejection reason walks & quacks like an axios error.
//
// Registered on CAPTURE phase so we fire BEFORE the webpack-dev-server client
// listener (which registers on bubble during dev-server bootstrap), and
// `stopImmediatePropagation()` prevents the overlay listener from ever seeing
// the event. `preventDefault()` also silences the default browser console log.
// Prod behavior is unchanged (this whole block is a no-op).
if (typeof window !== "undefined" && process.env.NODE_ENV !== "production") {
  window.addEventListener("unhandledrejection", (event) => {
    const r = event.reason;
    const isAxios = !!(r && (r.isAxiosError || r.name === "AxiosError" || r.config));
    if (isAxios) {
      console.debug("[dev] Swallowed unhandled AxiosError:",
        r?.response?.status, r?.config?.method?.toUpperCase(), r?.config?.url);
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  }, true);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
